import React from 'react';
//import { useSelector } from 'react-redux';
import PatientForm from '../../../components/PatientForm/PatientForm';
import "./style.scss";

function AddPatient() {
  //const user = useSelector((state) => state.auth?.user?.data);

  /* if (user?.role_id !== 1) {
    return "Your are not authorized to view this page";
  } */
    
  return (
    <div>
        <PatientForm patient={null} />
    </div>
  );
}

export default AddPatient;
